// src/components/MainAppControlComponent.js
import React from 'react';
// --- 1. REMOVE Switch and FormControlLabel from imports ---
import { 
    Button, Card, CardContent, Typography, CircularProgress, 
    Box, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { ACCEPTED_IMAGE_TYPES_STRING } from '../constants';


// --- 2. REMOVE the usePublicDataset and setUsePublicDataset props ---
const MainAppControlComponent = ({ 
    handleFileUpload, 
    handleProcessImages, 
    handleReset, 
    isProcessing, 
    hasFiles,
    prior,
    setPrior 
}) => (
    <Card>
        <CardContent>
            <Typography variant="h6" component="h3" gutterBottom>
                Controls
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                <strong>Step 1:</strong> Upload images<br/>
                <strong>Step 2:</strong> Choose Identity Priors<br/>
                <strong>Step 3:</strong> Click Process Images
                <br/><br/>
                To define your own identities, use the "Pro Mode" in the upper right corner
            </Typography>


            <Box sx={{ my: 2 }}>
                <FormControl fullWidth>
                    <InputLabel id="prior-select-label">Temporal Prior</InputLabel>
                    <Select
                        labelId="prior-select-label"
                        id="prior-select"
                        value={prior}
                        label="Temporal Prior"
                        onChange={(e) => setPrior(e.target.value)}
                        disabled={isProcessing}
                    >
                        <MenuItem value="uniform">Uniform Prior (Weakest)</MenuItem>
                        <MenuItem value="decade">Decade Prior</MenuItem>
                        <MenuItem value="movie">Movie Prior (Strongest)</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            <Button component="label" variant="contained" startIcon={<UploadFileIcon />} fullWidth>
                Add More Files
                <input
                    type="file"
                    multiple
                    onChange={(e) => handleFileUpload(Array.from(e.target.files))}
                    accept={ACCEPTED_IMAGE_TYPES_STRING}
                    hidden
                />
            </Button>
            <Button
                onClick={handleProcessImages}
                disabled={isProcessing || !hasFiles}
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
            >
                {isProcessing ? <CircularProgress size={24} /> : 'Process Images'}
            </Button>
            <Button
                onClick={handleReset}
                disabled={isProcessing || !hasFiles}
                variant="contained"
                color="secondary"
                fullWidth
                sx={{ mt: 2 }}
            >
                Start Over
            </Button>
        </CardContent>
    </Card>
);
export default MainAppControlComponent;